import "./Reviews.css";
import Title from "../Title/title";

function Reviews() {
  return (
    <div className="content" id="Reviews">
      <div className="heading">
        <Title title="Отзывы" translate="Reviews" />
      </div>
      <div className="reviews-wrapper">
        <div className="reviews-container">
          <div className="reviews-iframe-wrapper">
            <iframe
              className="reviews-iframe"
              src="https://yandex.ru/maps-reviews-widget/69695005530?comments"
              title="Отзывы Яндекс Карты"
              loading="lazy"
            ></iframe>
            <a
              href="https://yandex.ru/maps/org/alyona_troshina_permanentny_makiyazh/69695005530/"
              target="_blank"
              rel="noopener noreferrer"
              className="reviews-link"
            >
              Алёна Трошина - Перманентный макияж на карте Чехова — Яндекс Карты
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews;
